module.exports = new __parcel__URL__("report-created-vs-resolved.75277fe6.svg").toString();